import { baseEnvironment } from './base-environment';

export const environment = {
  ...baseEnvironment,
    //apiServerUrl: 'http://localhost:60000/api/',
    //socketsServerUrl: 'http://localhost:60000/notificationhub',

};
